<template>
  <ButtonDialog
    ref="viewButtonDialog"
    :modelValue="visible"
    :dialogTitle="title"
    dialogWidth="50%"
    dialogTop="5vh"
    :onlyCloseBtn="true"
    @update:modelValue="$emit('update:visible', $event)"
    @close="handleClose">
    <slot>
      <div class="view-dialog-content">
        <!-- 自定义Tab标签页 -->
        <div class="custom-tabs">
          <div class="custom-tabs-header">
            <div 
              class="custom-tab-item" 
              :class="{ active: activeTab === 'migrate' }"
              @click="handleTabClick('migrate')">
              <span class="tab-label">关联网关数据</span>
              <div class="tab-indicator"></div>
            </div>
            <div 
              class="custom-tab-item" 
              :class="{ active: activeTab === 'import' }"
              @click="handleTabClick('import')">
              <span class="tab-label">NPY文件上传数据</span>
              <div class="tab-indicator"></div>
            </div>
          </div>
          <div class="custom-tabs-content">
            <!-- 迁移标签页内容 -->
            <div v-show="activeTab === 'migrate'" class="tab-pane">
              <MigrateTab
                ref="migrateTab"
                :label-id="labelId"
                @view-wave="handleViewWave"
                @migrate="handleMigrate"
                @batch-migrate="handleBatchMigrate"
              />
            </div>
            <!-- 导入标签页内容 -->
            <div v-show="activeTab === 'import'" class="tab-pane">
              <ImportTab
                ref="importTab"
                :label-id="labelId"
                :dict-item-id="dictItemId"
                @view-wave="handleViewWave"
                @migrate="handleMigrate"
                @batch-migrate="handleBatchMigrate"
              />
            </div>
          </div>
        </div>
      </div>
    </slot>
  </ButtonDialog>
</template>

<script>
import ButtonDialog from '@/components/dialog/ButtonDialog.vue'
import MigrateTab from './tabs/MigrateTab.vue'
import ImportTab from './tabs/ImportTab.vue'

export default {
  name: 'LabelDetailTabsDialog',
  components: {
    ButtonDialog,
    MigrateTab,
    ImportTab
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '查看标签详情'
    },
    labelId: {
      type: [String, Number, null],
      default: null
    },
    dictItemId: {
      type: [String, Number, null],
      default: null
    }
  },
  data() {
    return {
      activeTab: 'migrate' // 默认选中迁移标签页
    }
  },
  watch: {
    visible(val) {
      if (val && this.labelId) {
        // 当弹框打开时，重置到默认标签页并加载数据
        this.activeTab = 'migrate'
        this.loadCurrentTabData()
      }
    },
    labelId(val) {
      if (this.visible && val) {
        // 当labelId变化时，重新加载当前标签页的数据
        this.loadCurrentTabData()
      }
    }
  },
  methods: {
    // 加载当前标签页的数据
    loadCurrentTabData() {
      if (this.activeTab === 'migrate') {
        this.$refs.migrateTab && this.$refs.migrateTab.loadData()
      } else if (this.activeTab === 'import') {
        this.$refs.importTab && this.$refs.importTab.loadData()
      }
    },
    
    // Tab切换事件
    handleTabClick(tabName) {
      this.activeTab = tabName
      // 切换标签页时重新加载数据
      this.loadCurrentTabData()
    },
    
    // 查看波形事件
    handleViewWave(waveId) {
      this.$emit('view-wave', waveId)
    },
    
    // 单个迁移事件
    handleMigrate(recordIds, activeTab) {
      this.$emit('migrate', recordIds, activeTab)
    },
    
    // 批量迁移事件
    handleBatchMigrate(recordIds, activeTab) {
      this.$emit('batch-migrate', recordIds, activeTab)
    },
    
    // 处理关闭
    handleClose() {
      // 重置到默认标签页
      this.activeTab = 'migrate'
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.view-dialog-content {
  padding: 0 20px;
}

/* 自定义Tab样式 */
.custom-tabs {
  width: 100%;
}

.custom-tabs-header {
  display: flex;
  border-bottom: 2px solid #f0f2f5;
  margin-bottom: 24px;
  position: relative;
}

.custom-tab-item {
  position: relative;
  padding: 0 32px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  margin-right: 8px;
  border-radius: 8px 8px 0 0;
}

.tab-label {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.tab-indicator {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 80%;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color) 0%, rgba(0, 216, 195, 0.8) 100%);
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
}

/* 悬停效果 */
.custom-tab-item:hover {
  background: rgba(0, 216, 195, 0.08);
}

.custom-tab-item:hover .tab-label {
  color: var(--primary-color);
  transform: translateY(-1px);
}

/* 激活状态 */
.custom-tab-item.active {
  background: rgba(0, 216, 195, 0.05);
}

.custom-tab-item.active .tab-label {
  color: var(--primary-color);
  font-weight: 600;
  font-size: 16px;
}

.custom-tab-item.active .tab-indicator {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}

/* 点击动画 */
.custom-tab-item:active {
  transform: scale(0.98);
}

/* 内容区域 */
.custom-tabs-content {
  min-height: 400px;
}

.tab-pane {
  animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .custom-tab-item {
    padding: 0 20px;
    height: 44px;
  }
  
  .tab-label {
    font-size: 14px;
  }
}
</style>